export const DELETION_CONFIRMATION_TEXT = "delete";
